export default __webpack_public_path__ + "static/media/deftstabs1.db598eb7.png";